<template lang="pug">
  v-btn.text-none(:color="color" :dark="dark" large depressed :disabled="disabled" :text="simple" @click="$emit('click')" :fixed="fixed" :bottom="bottom")
    slot
</template>

<script>
export default {
  name: 'app-button',

  props: {
    color: String,
    disabled: Boolean,
    simple: Boolean,
    dark: {
        default:true,
        type:Boolean
    },
    fixed: Boolean,
    bottom: Boolean,
  }
}
</script>


